"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Agent_1 = __importDefault(require("./Agent"));
const mutations = __importStar(require("./graphql/mutations"));
const queries = __importStar(require("./graphql/queries"));
const subscriptions = __importStar(require("./graphql/subscriptions"));
const Log_1 = __importDefault(require("../Log"));
const Validate_1 = require("../util/Validate");
const AppSyncConsumer_1 = __importDefault(require("./AppSyncConsumer"));
class Storage extends AppSyncConsumer_1.default {
    constructor(appSyncClient, environmentId) {
        super(appSyncClient);
        this._observables = new Map();
        this._environmentId = environmentId;
    }
    get observables() {
        return this._observables;
    }
    writeToStorage(key, value, agent) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            Validate_1.Validate.storageKeyValue(key, value, agent);
            const variables = {
                environmentId: this._environmentId,
                key,
                value,
                agentId: agent === null || agent === void 0 ? void 0 : agent.id
            };
            Log_1.default.debug('Put request arguments:', variables);
            const response = yield this._client
                .mutate({
                mutation: mutations.putPersistentData,
                variables
            })
                .catch((err) => {
                Log_1.default.error('Failed to write to storage', err);
                throw Error(err);
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.putPersistentData;
        });
    }
    getFromStorage(key, agent) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!key || !key.length) {
                throw Error('Key cannot be empty');
            }
            if (agent !== undefined && !(agent instanceof Agent_1.default)) {
                throw Error(`Invalid agent provided`);
            }
            const variables = {
                environmentId: this._environmentId,
                key,
                agentId: agent === null || agent === void 0 ? void 0 : agent.id
            };
            Log_1.default.debug('Get request arguments:', variables);
            const response = yield this._client
                .query({
                query: queries.getPersistentData,
                variables,
                fetchPolicy: 'no-cache'
            })
                .catch((err) => {
                Log_1.default.error('Failed to get key from storage', err);
                throw Error(err);
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.getPersistentData.value;
        });
    }
    getKeysFromStorage(agent) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (agent !== undefined && !(agent instanceof Agent_1.default)) {
                throw Error(`Invalid agent provided`);
            }
            const variables = {
                environmentId: this._environmentId,
                agentId: agent === null || agent === void 0 ? void 0 : agent.id
            };
            Log_1.default.debug('Get keys list arguments:', variables);
            const response = yield this._client.query({
                query: queries.getPersistentDataKeys,
                variables,
                fetchPolicy: 'no-cache'
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.getPersistentDataKeys;
        });
    }
    removeFromStorage(key, agent) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!key || !key.length) {
                throw Error('Key cannot be empty');
            }
            if (agent !== undefined && !(agent instanceof Agent_1.default)) {
                throw Error(`Invalid agent provided`);
            }
            const variables = {
                environmentId: this._environmentId,
                key: key,
                agentId: agent === null || agent === void 0 ? void 0 : agent.id
            };
            Log_1.default.debug('Remove key arguments:', variables);
            const response = yield this._client
                .mutate({
                mutation: mutations.removePersistentData,
                variables
            })
                .catch((err) => {
                Log_1.default.error('Failed to remove key from storage', err);
                throw Error(err);
            });
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.removePersistentData;
        });
    }
    removeAllFromStorage(agent) {
        return __awaiter(this, void 0, void 0, function* () {
            if (agent !== undefined && !(agent instanceof Agent_1.default)) {
                throw Error('Invalid agent provided');
            }
            const keys = yield this.getKeysFromStorage(agent);
            for (const item of keys) {
                const variables = {
                    environmentId: this._environmentId,
                    key: item.key,
                    agentId: item.agentId
                };
                Log_1.default.debug('Remove key arguments:', variables);
                yield this._client
                    .mutate({
                    mutation: mutations.removePersistentData,
                    variables
                })
                    .catch((err) => {
                    Log_1.default.error('Failed to remove key from storage', err);
                    throw Error(err);
                });
            }
            return keys;
        });
    }
    subscribeToStorage(key, agent, handler) {
        if (!key || !key.length) {
            throw Error('Key cannot be empty');
        }
        if (agent !== undefined && !(agent instanceof Agent_1.default)) {
            throw Error(`Invalid agent provided`);
        }
        const variables = {
            environmentId: this._environmentId,
            key: key,
            agentId: agent === null || agent === void 0 ? void 0 : agent.id
        };
        Log_1.default.debug('Subscribe arguments:', variables);
        const obs = this._client.subscribe({ query: subscriptions.persistentDataUpdated, variables }).subscribe({
            next: ({ data }) => {
                Log_1.default.trace(data);
                const { environmentId, key, value, agentId, type } = data.persistentDataUpdated;
                handler === null || handler === void 0 ? void 0 : handler({ environmentId, key, value, agentId, type });
            },
            error: ({ error }) => {
                Log_1.default.error('Storage subscription error', error);
            },
            complete: () => {
                Log_1.default.debug('Storage subscription complete');
            }
        });
        this._observables.set(JSON.stringify({ key, agentId: agent === null || agent === void 0 ? void 0 : agent.id }), obs);
    }
    unsubscribeFromStorage(key, agent) {
        var _a;
        if (!key || !key.length) {
            throw Error('Key cannot be empty');
        }
        if (agent !== undefined && !(agent instanceof Agent_1.default)) {
            throw Error(`Invalid agent provided`);
        }
        Log_1.default.debug('Unsubscribe arguments:', { key, agentId: agent === null || agent === void 0 ? void 0 : agent.id });
        (_a = this._observables.get(JSON.stringify({ key, agentId: agent === null || agent === void 0 ? void 0 : agent.id }))) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
exports.default = Storage;
//# sourceMappingURL=Storage.js.map